(function ($) {
    if(! $('body').is('.logged-in')){
        return false;
    }

    $(document).on('click', '#download-user-personal-data', function (e) {
        let data = {
            action: 'download_user_personal_data',
        };

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            success: function (response) {
                if (response.success) {
                    downloadFile(response.url, response.name)
                }
            },
        });

        return false;
    });

})(jQuery);

function downloadFile(fileUrl, fileName) {
    let a = document.createElement("a");
    a.href = fileUrl;
    a.setAttribute("download", fileName);
    a.click();
}